import { Button, Container, ScrollView, Spinner, isWeb } from '@my/ui'
import { Share2 } from '@tamagui/lucide-icons'
import { MainLayout, Meta, NativePageNavigation, StructuredMeta } from 'app/components'
import config from 'app/config'
import { useShare } from 'app/features/sharing/hooks'
import { ArticleQueryOutput } from './queries'
import { Article } from '../../components'

export interface ArticleScreenProps {
  loading: boolean
  article?: ArticleQueryOutput['Articles']['docs'][0]
}

export const ArticleScreen = (props: ArticleScreenProps) => {
  const shareLinkUrl = props.article?.slug ? `${config.siteUrl}/life/${props.article.slug}` : ''

  const { onShare } = useShare({
    href: shareLinkUrl,
  })

  if (props.loading || !props.article) {
    return (
      <MainLayout>
        <Container flex={1} justifyContent="center">
          <Spinner size="large" />
        </Container>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <Meta
        title={props.article.meta.title || props.article.title}
        description={props.article.meta.description}
        image={props.article.featuredImage?.url}
      />
      <StructuredMeta
        type="article"
        title={props.article.title}
        description={props.article.meta.description || ''}
        image={props.article.featuredImage?.url}
        date={props.article.updatedAt}
        url={`${config.siteUrl}/life/${props.article.slug}`}
      />
      <StructuredMeta
        type="breadcrumb"
        breadcrumbs={[
          {
            name: 'Home',
            url: config.siteUrl,
          },
          {
            name: 'Life',
            url: `${config.siteUrl}/life`,
          },
          {
            name: props.article.title,
            url: `${config.siteUrl}/life/${props.article.slug}`,
          },
        ]}
      />
      {!isWeb && (
        <NativePageNavigation
          title={props.article.title}
          Controls={[
            <Button
              key="share"
              px="$3"
              plain
              icon={<Share2 size={24} />}
              onPress={onShare}
            />,
          ]}
        />
      )}
      <ScrollView>
        <Container size="base" gutter="gtSm" spaceBottom>
          <Article
            title={props.article.title}
            primaryCategory={props.article.primaryCategory}
            featuredImage={props.article.featuredImage}
            content={props.article.content}
            slug={props.article.slug || ''}
            shareLinkUrl={shareLinkUrl}
          />
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
